import { mutationOptions, queryOptions } from '@tanstack/react-query';

import { API_SERVICE } from '@/constants/api.constant';
import { GET, UPLOAD_FILE } from '@/lib/fetch';
import type { FileRequest } from '@/types/file';
import type { ErrorApiResponse, SuccessResponse } from '@/types/response';

export const fileQueries = {
	keys: () => 'file',
	getPresign: (query: FileRequest) =>
		queryOptions<SuccessResponse<{ url: string }>, ErrorApiResponse>({
			queryKey: [fileQueries.keys(), query],
			queryFn: () =>
				GET({ path: '/files/presigned', service: API_SERVICE.API, query })
		})
};

type FileUploadRequest = {
	key: string,
	file: File,
	onProgress?: (percentage: number) => void
};

export const fileMutations = {
	uploadPresign: mutationOptions<string, Error, FileUploadRequest>({
		mutationFn: async (payload) => {
			const sasUrl = await GET<SuccessResponse<{ url: string }>>({
				path: '/files/presigned',
				service: API_SERVICE.API,
				query: { key: payload.key, permission: 'wr' }
			});

			await UPLOAD_FILE({
				file: payload.file,
				sasUrl: sasUrl.data.url,
				onProgress: payload.onProgress
			});
			return sasUrl.data.url;
		}
	}),
	getPresign: mutationOptions<
		SuccessResponse<{ url: string }>,
		ErrorApiResponse,
		{ key: string }
	>({
		mutationFn: ({ key }) =>
			GET<SuccessResponse<{ url: string }>>({
				path: '/files/presigned',
				service: API_SERVICE.API,
				query: { key }
			})
	})
};
